import {
	IModel,
	IIdentifiable,
	ISortable,
} from "@/loader";

export interface IWPTerm extends IIdentifiable, ISortable {
	term_id?: number;
	name?: string;
	slug?: string;
	term_group?: number | null;
	term_taxonomy_id?: number | null;
	taxonomy?: string;
	description?: string | null;
	edit_url?: string | null;
}

export interface IWPTermHierarchy extends IWPTerm {
	parent?: number | null;
}

export interface IWPTermOptions {
	name?: boolean;
	slug?: boolean;
	term_group?: boolean;
	term_taxonomy_id?: boolean;
	taxonomy?: boolean;
	description?: boolean;
	edit_url?: boolean;
}

export interface IWPTermHierarchyOptions extends IWPTermOptions {
	parent?: boolean;
}

export class WPTerm implements IWPTerm, IModel<IWPTerm> {
	public id!: number;
	public name!: string;
	public slug!: string;
	public term_group!: number | null;
	public term_taxonomy_id!: number | null;
	public taxonomy!: string;
	public description!: string | null;
	public edit_url!: string | null;
	public order!: number;

	public get term_id(): number {
		return this.id;
	}

	public set term_id(value: number) {
		this.id = value;
	}

	public get uniqId(): string {
		return "term" + this.id;
	}

	public constructor(data: IWPTerm = {}) {
		this.load(data);
	}

	public load(data: IWPTerm) {
		this.id = Number.orDefault(data.id || data.term_id);
		this.name = String.orDefault(data.name);
		this.slug = String.orDefault(data.slug);
		this.term_group = Number.nullable(data.term_group);
		this.term_taxonomy_id = Number.nullable(data.term_taxonomy_id);
		this.taxonomy = String.orDefault(data.taxonomy);
		this.description = String.nullable(data.description);
		this.edit_url = String.nullable(data.edit_url);
		this.order = Number.orDefault(data.order);
	}

	public update(data: IWPTerm) {
		if (data.id !== undefined) {
			this.id = Number.orDefault(data.id);
		}
		if (data.term_id !== undefined) {
			this.id = Number.orDefault(data.term_id);
		}
		if (data.name !== undefined) {
			this.name = String.orDefault(data.name);
		}
		if (data.slug !== undefined) {
			this.slug = String.orDefault(data.slug);
		}
		if (data.term_group !== undefined) {
			this.term_group = Number.nullable(data.term_group);
		}
		if (data.term_taxonomy_id !== undefined) {
			this.term_taxonomy_id = Number.nullable(data.term_taxonomy_id);
		}
		if (data.taxonomy !== undefined) {
			this.taxonomy = String.orDefault(data.taxonomy);
		}
		if (data.description !== undefined) {
			this.description = String.nullable(data.description);
		}
		if (data.edit_url !== undefined) {
			this.edit_url = String.nullable(data.edit_url);
		}
		if (data.order !== undefined) {
			this.order = Number.orDefault(data.order);
		}
	}
}

export class WPTermHierarchy extends WPTerm implements IWPTermHierarchy, IModel<IWPTermHierarchy> {
	public parent!: number | null;

	public constructor(data: IWPTermHierarchy = {}) {
		super();
		this.load(data);
	}

	public load(data: IWPTermHierarchy) {
		super.load(data);
		this.parent = Number.nullable(data.parent);
	}

	public update(data: IWPTermHierarchy) {
		super.update(data);
		if (data.parent !== undefined) {
			this.parent = Number.nullable(data.parent);
		}
	}

	public static compareByParent(a: IWPTermHierarchy, b: IWPTermHierarchy): number {
		return (!a || !a.parent) && (!b || !b.parent) ? 0
			: (!a || !a.parent) ? -1
			: (!b || !b.parent) ? 1
			: a.parent > b.parent ? 1
			: a.parent < b.parent ? -1
			: 0;
	}
}
